'use client';

import { createPortal } from 'react-dom';

import StoreConfig from '@/config';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';

interface Props {
  isProductPage?: boolean;
  isCategoryPage?: boolean;
  productCategories?: any[];
  isConfigurableProduct?: boolean;
  productUrl?: string;
}

const HrefLangLinks = (props: Props) => {
  const { isProductPage = false, isCategoryPage = false, productCategories, isConfigurableProduct, productUrl } = props;

  const pathname = usePathname();

  if (isProductPage) {
    // 分类 /swatches 或者 /fabrics
    const isSwatch = productCategories?.some(x => x?.uid === 'NDI=' || x?.uid === 'NDM=');

    if (isConfigurableProduct && !isSwatch) {
      return null;
    }
  }

  if (isCategoryPage) {
    const currentUrlKey = pathname.split('/').filter(Boolean)[0];

    if (!AVAILABLE_CATEGORY_URL_KEYS.includes(currentUrlKey)) {
      return null;
    }
  }

  return createPortal(
    StoreConfig.available_countries.reduce<ReactNode[]>((acc, x) => {
      let nextPathname = isProductPage ? productUrl || '' : pathname;

      if (isCategoryPage) {
        if (x.code === 'us') {
          nextPathname = nextPathname
            .replace('/colours-family', '/colors-family')
            .replace('/autumn-wedding-guest-dresses', '/fall-wedding-guest-dresses');
        } else if (x.code === 'uk') {
          nextPathname = nextPathname
            .replace('/colors-family', '/colours-family')
            .replace('/fall-wedding-guest-dresses', '/autumn-wedding-guest-dresses');
        } else {
          if (x.code === 'au') {
            nextPathname = nextPathname.replace('/fall-wedding-guest-dresses', '/autumn-wedding-guest-dresses');
          }

          nextPathname = nextPathname.replace('/colours-family', '/colors-family');
        }
      }

      if (nextPathname === '/') {
        nextPathname = '';
      }

      if (x.code === 'us') {
        acc.push(
          <link
            rel='alternate'
            hrefLang='x-default'
            key='x-default'
            href={`https://www.${x.url}${nextPathname}`}
          />,
        );
      }

      acc.push(
        <link
          rel='alternate'
          hrefLang={x.hreflang}
          key={x.code}
          href={`https://www.${x.url}${nextPathname}`}
        />,
      );

      return acc;
    }, []),
    document.head,
  );
};

export default HrefLangLinks;

const AVAILABLE_CATEGORY_URL_KEYS = [
  'bridesmaid-dresses',
  'long-bridesmaid-dresses',
  'short-bridesmaid-dresses',
  'floral-bridesmaid-dresses',
  'convertible-bridesmaid-dresses',
  'plus-size-dresses',
  'maternity-bridesmaid-dresses',
  'junior-bridesmaid-dresses',
  'swatches',
  'shop-by-fabric',
  'free-moodboard',
  'real-wedding',
  'size-chart',
  'wedding-dresses',
  'plus-size-wedding-dresses',
  'little-white-dresses',
  'floral-wedding-dresses',
  'convertible-wedding-dresses',
  'boho-wedding-dresses',
  'beach-wedding-dresses',
  'wedding-guest-dresses',
  'black-tie-wedding-guest-dresses',
  'spring-wedding-guest-dresses',
  'plus-size-wedding-guest-dresses',
  'casual-wedding-guest-dresses',
  'cocktail-wedding-guest-dresses',
  'beach-wedding-guest-dresses',
  'garden-wedding-guest-dresses',
  'country-wedding-guest-dresses',
  'summer-wedding-guest-dresses',
  'autumn-wedding-guest-dresses',
  'fall-wedding-guest-dresses',
  'winter-wedding-guest-dresses',
  'mother-of-the-bride-dresses',
  'spring-mother-of-the-bride-dresses',
  'mother-of-the-bride-dresses-with-wraps',
  'dresses',
  'floral-dresses',
  'reborn-collection-dresses',
  'prom-dresses',
  'homecoming-dresses',
  'graduation-dresses',
  'formal-dresses',
  'fabrics',
  'wedding-sales',
  'bridesmaid-dresses-sale',
  'wedding-dresses-sale',
];
